import styled from 'styled-components';

export const CardHeaderRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px 20px;
  min-height: 68px;
  border-bottom: 1px solid ${({ theme }) => theme.palette.divider};
`;
